import {
  NumberField,
  EmailField,
  useTranslate,
  Show,
  SimpleShowLayout,
  TextField,
  FunctionField
} from "react-admin";
import CustomHeaderActions from "./CustomHeaderActions";
import ShowAndEditDetails from "./ShowAndEditDetails";
import { PlatformSettingsIcon } from "../assets/Icons";

export default function PlatformShow() {
  const translate = useTranslate();

  return (
    <Show
      actions={
        <CustomHeaderActions title={translate("platform.platform_settings")} />
      }
    >
      <SimpleShowLayout>
        <ShowAndEditDetails
          title={translate("platform.platform_settings_details")}
          view="show"
          icon={<PlatformSettingsIcon />}
          marginBottom="4px"
        />
        <EmailField
          source="contact_email"
          label={translate("platform.contact_email")}
        />
        {/* <NumberField
          source="amount_billed_per_appointment"
          label={translate("platform.amount_billed_per_appointment")}
        /> */}
        <FunctionField
          source="amount_billed_per_appointment"
          label={translate("platform.amount_billed_per_appointment")}
          render={(record: any) => {
            const value = record?.amount_billed_per_appointment;
            return `${value}%`;
          }}
        />
        <NumberField
          source="service_price_per_month"
          label={translate("platform.service_price_per_month")}
        />
        <NumberField
          source="percent_billed_from_pos"
          label={translate("platform.percent_billed_from_pos")}
        />
        <NumberField
          source="appointment_reminder_hours_before"
          label={translate("platform.appointment_reminder_hours_before")}
        />
        <TextField
          source="feature_flag_restricted_sign_up"
          label={translate("platform.feature_flag_restricted_sign_up")}
        />
      </SimpleShowLayout>
    </Show>
  );
}
